/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitDocumentDetail,
    PressKitDocumentDetailFromJSON,
    PressKitDocumentDetailFromJSONTyped,
    PressKitDocumentDetailToJSON,
} from './PressKitDocumentDetail';

/**
 * 
 * @export
 * @interface GetPressKitDocumentDetailResponse
 */
export interface GetPressKitDocumentDetailResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitDocumentDetailResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitDocumentDetailResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitDocumentDetail}
     * @memberof GetPressKitDocumentDetailResponse
     */
    data: PressKitDocumentDetail;
}

export function GetPressKitDocumentDetailResponseFromJSON(json: any): GetPressKitDocumentDetailResponse {
    return GetPressKitDocumentDetailResponseFromJSONTyped(json, false);
}

export function GetPressKitDocumentDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitDocumentDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitDocumentDetailFromJSON(json['data']),
    };
}

export function GetPressKitDocumentDetailResponseToJSON(value?: GetPressKitDocumentDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitDocumentDetailToJSON(value.data),
    };
}

